import { render, staticRenderFns } from "./hakkimizda.vue?vue&type=template&id=0df28120&scoped=true&"
import script from "./hakkimizda.vue?vue&type=script&lang=js&"
export * from "./hakkimizda.vue?vue&type=script&lang=js&"
import style0 from "./hakkimizda.vue?vue&type=style&index=0&id=0df28120&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df28120",
  null
  
)

export default component.exports